(function() {
  if (window.__fjMonthlyBoxCollapsiblePromoInit) return;
  window.__fjMonthlyBoxCollapsiblePromoInit = true;

  function parsePercentValue(rawText) {
    if (!rawText) return null;
    var match = String(rawText).match(/(\d+(?:[\.,]\d+)?)/);
    if (!match) return null;
    var normalized = match[1].replace(',', '.');
    var parsed = parseFloat(normalized);
    if (!isFinite(parsed) || parsed <= 0) return null;
    return parsed % 1 === 0
      ? String(Math.round(parsed))
      : String(parsed.toFixed(1)).replace(/\.0$/, '');
  }

  function getSavingPercentSpan(sectionRoot) {
    return (
      (sectionRoot && sectionRoot.querySelector('.saving span')) ||
      (sectionRoot && sectionRoot.querySelector('product-meta .saving span')) ||
      document.querySelector('#main product-meta .saving span') ||
      document.querySelector('#main .saving span')
    );
  }

  function getPdpSavingPercent(root) {
    var sectionRoot = root.closest('.shopify-section') || document;
    var savingPercentEl = getSavingPercentSpan(sectionRoot);
    var parsedFromSaving = parsePercentValue(savingPercentEl && savingPercentEl.textContent);
    if (parsedFromSaving) return parsedFromSaving;

    var compareEl = sectionRoot.querySelector('.product-meta__price-list-container .price--compare');
    var saleEl = sectionRoot.querySelector('.product-meta__price-list-container .price--highlight');
    if (!compareEl || !saleEl) return null;

    var compareRaw = (compareEl.textContent || '').replace(/[^\d.,]/g, '').replace(',', '.');
    var saleRaw = (saleEl.textContent || '').replace(/[^\d.,]/g, '').replace(',', '.');
    var comparePrice = parseFloat(compareRaw);
    var salePrice = parseFloat(saleRaw);
    if (!isFinite(comparePrice) || !isFinite(salePrice) || comparePrice <= 0 || salePrice <= 0 || salePrice >= comparePrice) {
      return null;
    }

    var pct = ((comparePrice - salePrice) / comparePrice) * 100;
    return String(Math.round(pct));
  }

  function syncUnlockPercentForRoot(root) {
    if (!root) return;
    var dynamicPercent = getPdpSavingPercent(root);
    if (!dynamicPercent) return;

    var percentTarget = root.querySelector('[data-monthly-box-unlock-percent]');
    if (percentTarget) {
      percentTarget.textContent = dynamicPercent;
      return;
    }

    var summaryRte = root.querySelector('.monthly-box-collapsible-promo__summary-text');
    if (!summaryRte) return;
    var strong = summaryRte.querySelector('strong');
    if (!strong) return;
    var html = strong.innerHTML;
    if (/\d+(?:[\.,]\d+)?\s*%/.test(html)) {
      strong.innerHTML = html.replace(/\d+(?:[\.,]\d+)?\s*%/, dynamicPercent + '%');
    }
  }

  function syncUnlockPercentsAll() {
    document
      .querySelectorAll('.monthly-box-collapsible-promo')
      .forEach(syncUnlockPercentForRoot);
  }

  function onDocumentClick(e) {
    var openBtn = e.target.closest('[data-why-subscribe-open-drawer]');
    if (openBtn) {
      var root = openBtn.closest('.monthly-box-collapsible-promo');
      if (root) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof window.fjOpenMonthlyBoxQuickBuyDrawer === 'function') {
          var pid = openBtn.getAttribute('data-monthly-box-product-id');
          var drawerIdHint = root.getAttribute('data-monthly-box-drawer-id') || '';
          window.fjOpenMonthlyBoxQuickBuyDrawer(pid || '', drawerIdHint);
        }
        return;
      }
    }

    var addBtn = e.target.closest('[data-monthly-box-collapsible-trigger-add]');
    if (!addBtn) return;
    var addRoot = addBtn.closest('.monthly-box-collapsible-promo');
    if (!addRoot) return;

    e.preventDefault();
    var widget = document.querySelector('.monthly-box-widget');
    if (!widget) return;
    var innerAdd = widget.querySelector('.monthly-box-widget__add-button');
    if (innerAdd) innerAdd.click();
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('variant:changed', function() {
    setTimeout(syncUnlockPercentsAll, 120);
  });

  function attachSavingObserverOnce() {
    if (attachSavingObserverOnce.done) return;
    var savingHost =
      document.querySelector('#main product-meta .saving') ||
      document.querySelector('#main .saving');
    if (!savingHost) return;
    attachSavingObserverOnce.done = true;
    var mo = new MutationObserver(function() {
      syncUnlockPercentsAll();
    });
    mo.observe(savingHost, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncUnlockPercentsAll();
      setTimeout(function() {
        syncUnlockPercentsAll();
        attachSavingObserverOnce();
      }, 150);
    });
  } else {
    syncUnlockPercentsAll();
    setTimeout(function() {
      syncUnlockPercentsAll();
      attachSavingObserverOnce();
    }, 150);
  }
})();
